module.exports = __webpack_public_path__ + "static/media/ic_train.576fcf43.png";